var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[(!_vm.error)?_c('div',{staticClass:"loading"}):_c('div',{staticClass:"error-message"},[_c('h2',[_vm._v("Uh oh.. something went wrong. Try reloading the page.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }